var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNextGearCar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 293,
    height: 244,
    viewBox: "0 0 293 244",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M51.2348 5.68447C52.8179 2.22133 56.2758 0 60.0837 0H232.91C236.718 0 240.176 2.22133 241.759 5.68448L269.929 67.3058C272.875 73.7498 268.166 81.0807 261.08 81.0807H31.9139C24.8286 81.0807 20.1192 73.7498 23.065 67.3058L51.2348 5.68447Z",
    fill: "#ffffff"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.4629 113.513C9.59479 113.513 5.99519 126.509 14.457 131.586L62.2979 160.29L62.2967 160.293C65.1366 161.992 67.038 165.098 67.038 168.648C67.038 173.748 63.1133 177.932 58.1191 178.344V178.378H10.2814C4.90789 178.378 0.551758 182.734 0.551758 188.107V233.512C0.551758 238.886 4.90789 243.242 10.2814 243.242H55.6866C61.0602 243.242 65.4163 238.886 65.4163 233.512V218.918C66.1883 214.316 70.325 210.81 75.146 210.81H217.848C222.669 210.81 226.806 214.316 227.578 218.918V233.512C227.578 238.886 231.934 243.242 237.307 243.242H282.713C288.086 243.242 292.442 238.886 292.442 233.512V188.107C292.442 182.734 288.086 178.378 282.713 178.378H234.875V178.344C229.881 177.932 225.956 173.748 225.956 168.648C225.956 165.098 227.858 161.992 230.697 160.293L230.696 160.29L278.537 131.586C286.999 126.509 283.399 113.513 273.531 113.513H19.4629ZM107.578 145.945C102.205 145.945 97.8486 150.301 97.8486 155.675V168.648C97.8486 174.021 102.205 178.378 107.578 178.378H185.416C190.789 178.378 195.145 174.021 195.145 168.648V155.675C195.145 150.301 190.789 145.945 185.416 145.945H107.578Z",
    fill: "#ffffff"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNextGearCar);
export default __webpack_public_path__ + "static/media/next-gear-car.2ba77082684bc4f483490e2658bd5267.svg";
export { ForwardRef as ReactComponent };